import {RunView} from "./RunView.js";
import {Task} from "@megaphonenpm/mputils/src/Task.js";
import {MegaScreen} from "./MegaScreen.js";
import {
  INITED
} from '@megaphonenpm/mputils/src/constants.js';

export class CreateRunViewsTask extends Task {
  constructor () {
    super();
    this.name = 'CREATE_RUN_VIEWS';
  }

  start () {
    super.start();

    // Create a RunView for each theme
    let numRunViewsInited = 0;
    MegaScreen.globals.dataStore.themes.forEach(theme => {
      let runView = new RunView(theme.id);
      runView.on(INITED, e => {
        // After each RunView has finished initialization, provide it with access to the model (appState).
        runView.setAppState(MegaScreen.globals.appState);
        numRunViewsInited++;
        if (numRunViewsInited === MegaScreen.globals.dataStore.themes.length) {
          this.done();
        }
      });
      // Store a reference to this new RunView in the application main View.
      MegaScreen.globals.view.runviews.push(runView);
      runView.init();
    });
  }
}
